module.exports = __webpack_public_path__ + "static/media/Icn-mdb.93f862c1.svg";